import { NgModule } from '@angular/core';
import { TranslocoHttpLoader } from '@digilize/shared/feature/modules/i18n/src';
import { provideTransloco, TranslocoModule } from '@ngneat/transloco';

import { environment } from '../environments/environment';
import { appConfig } from '../environments/app.config';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: appConfig.language.languages.map((el) => el.code),
        defaultLang: appConfig.language.defaultLanguage,
        fallbackLang: appConfig.language.defaultLanguage,
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
  ],
})
export class TranslocoRootModule {}
